import { makeActionCreator } from '../../config/store/utils'
import { getPurchasesSector } from '../../services/contingencies'

const COLORS_DICTIONARY = {
  'Fuerzas Armadas': 'purpureus',
  'Gobierno Central, Universidades': 'liberty',
  'Legislativo y Judicial': 'tuftsBlue',
  Municipalidades: 'burntSienna',
  'Obras Públicas': 'deepSaffron',
  Otros: 'forestGreenCrayola',
  Salud: 'orangeYellowCrayola'
}

export const GET_PURCHASES_SECTOR = 'GET_PURCHASES_SECTOR'
export const GET_PURCHASES_SECTOR_ERROR = 'GET_PURCHASES_SECTOR_ERROR'
export const GET_PURCHASES_SECTOR_SUCCESS = 'GET_PURCHASES_SECTOR_SUCCESS'
export const onGetPurchasesSector = makeActionCreator(GET_PURCHASES_SECTOR)
export const onGetPurchasesSectorError = makeActionCreator(GET_PURCHASES_SECTOR_ERROR, 'payload')
export const onGetPurchasesSectorSuccess = makeActionCreator(GET_PURCHASES_SECTOR_SUCCESS, 'payload')
export const onGetPurchasesSectorThunk = payload => async dispatch => {
  dispatch(onGetPurchasesSector())

  try {
    const { data = {} } = await getPurchasesSector({
      year: payload.year,
      contingencyId: payload.contingencySelected
    })
    const categories = data?.payload?.map(datum => datum.sector)
    const enhancedData = data.payload?.map(datum => ({
      amount: datum.amountCLP,
      amountUSD: datum.amountUSD,
      colorName: COLORS_DICTIONARY[datum.sector],
      name: datum.sector,
      orders: datum.qtyOC,
      percentage: datum.percentageCLP
    }))
    const csv = [
      ['Sectores', 'Nº de órdenes de compra', 'Monto total', 'Monto total (USD)'],
      ...data?.payload?.map(datum => [datum.sector, datum.qtyOC, datum.amountCLP, datum.amountUSD])
    ]

    return dispatch(onGetPurchasesSectorSuccess({ categories, csv, data: enhancedData }))
  } catch (error) {
    return dispatch(onGetPurchasesSectorError({ error }))
  }
}
